var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOfNoResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 9.99928C20.5 4.47608 25.0879 0 30.749 0C36.4101 0 40.998 4.47608 40.998 9.99928C40.998 15.5225 36.4101 19.9986 30.749 19.9986C25.0879 19.9986 20.5 15.5225 20.5 9.99928Z",
    fill: "#D7DFED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 30.0003C20.5 24.4771 25.0879 20.001 30.749 20.001C36.4101 20.001 40.998 24.4771 40.998 30.0003C40.998 35.5235 36.4101 39.9995 30.749 39.9995C25.0879 39.9995 20.5 35.5235 20.5 30.0003Z",
    fill: "#D7DFED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 30.0003C0 24.4771 4.58786 20.001 10.249 20.001C15.9101 20.001 20.498 24.4771 20.498 30.0003C20.498 35.5235 15.9101 39.9995 10.249 39.9995C4.58786 39.9995 0 35.5235 0 30.0003Z",
    fill: "#D7DFED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.99928C0 4.47608 4.58786 0 10.249 0C15.9101 0 20.498 4.47608 20.498 9.99928C20.498 15.5225 15.9101 19.9986 10.249 19.9986C4.58786 19.9986 0 15.5225 0 9.99928Z",
    fill: "#D7DFED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOfNoResult);
export default __webpack_public_path__ + "static/media/logoOfNoResult.e7fd68e03542def1b84e79fe7f97fbd0.svg";
export { ForwardRef as ReactComponent };